<template>
    <div class="home">
    <header>
      <WebHeader msg="WebHeader" />
      <SettingsHeader msg="SettingsHeader" />
    </header>
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <UserData type="web"/>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import UserData from "@/components/UserData.vue"
import WebHeader from "@/components/WebHeader.vue";
import SettingsHeader from "@/components/SettingsHeader.vue";

export default {
  name: "orders",
  components: {
    SettingsHeader,
    WebHeader,
    UserData
    
  }
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
</style>